// Date formatting YYYYMMDDHHMMSS
const dateFormat = "YYYYMMDDHHmmss";
const weekAbbreviations = ["Sun", "Mon", "Tue", "Wed", "Thur", "Fri", "Sat"];
const monthAbbreviations = ["Jan.", "Feb.", "Mar.", "Apr.", "May.", "Jun.", "Jul.", "Aug.", "Sep.", "Oct.", "Nov.", "Dec."];
const monthsForDateExtraction = ["January", "February", "March", "April", "May", "June", "Juli", "August", "September", "October", "November", "Dececmber"];
const moment = require('moment');


export function to_YYYYMMDDHHMMSS(date: Date): string {
  return (moment(date)).format(dateFormat).toString()
}

export function from_YYYYMMDDHHMMSS(dateString: string): Date {
  return moment(dateString, dateFormat).toDate()
}

export function datesAreOnSameDay(first: Date, second: Date): boolean {
  if (first && second) {
    if (first instanceof Date && second instanceof Date) {
      return first.getFullYear() === second.getFullYear() && first.getMonth() === second.getMonth() && first.getDate() === second.getDate();
    }
  }
  return false
}

export function dateStringsOnSameDay(firstDateString: string, secondDateString: string){
  return firstDateString.slice(0,8) === secondDateString.slice(0,8)
}

export function extractMonthAndYear(monthYearString: string | null){
  var monthindex = 0;
  var fullYear = 0;

  if(monthYearString){
    var [month, year] = monthYearString.split(',',2) 

    monthsForDateExtraction.forEach((monthItem, index) => {
      if(monthItem === month){
        monthindex = index;
        fullYear = parseInt(year);
      }
    })
  }

  return [monthindex, fullYear]
}

export function parseDates(body: any) {
  if (body === null || body === undefined || typeof body !== "object")
    return body;

  for (const key of Object.keys(body)) {
    const value = body[key];
    if (value instanceof Date) {
      body[key] = to_YYYYMMDDHHMMSS(value)
    }
  }
}

export function toDateTimeLocal(date: Date) {
  const ten = function (i: number) {
    return (i < 10 ? '0' : '') + i
  }
  const YYYY = date.getFullYear()
  const MM = ten(date.getMonth() + 1)
  const DD = ten(date.getDate())
  const HH = ten(date.getHours())
  const mm = ten(date.getMinutes())
  return YYYY + '-' + MM + '-' + DD + 'T' + HH + ':' + mm;
}

export function fromDateTimeLocal(dateTimeLocalString: string) {
  return to_YYYYMMDDHHMMSS(new Date(dateTimeLocalString))
}

export function prettyDate(date: string | Date, withTime: boolean, withDate: boolean): string {
  var tmpDate: Date = new Date();

  if(typeof date === 'string' || date instanceof String && !(date instanceof Date)){
    tmpDate = from_YYYYMMDDHHMMSS(date);
  } else if(date instanceof Date){
    tmpDate = date;
  }

  var hours = '';
  if (tmpDate.getHours() >= 0 && tmpDate.getHours() <= 9) {
    hours = '0' + tmpDate.getHours();
  } else {
    hours = '' + tmpDate.getHours();
  }
  var minutes = '';
  if (tmpDate.getMinutes() >= 0 && tmpDate.getMinutes() <= 9) {
    minutes = '0' + tmpDate.getMinutes();
  } else {
    minutes = '' + tmpDate.getMinutes();
  }


  if (withDate && !(withTime)) {
    return weekAbbreviations[tmpDate.getDay()] + " " + tmpDate.getDate() + " " + monthAbbreviations[tmpDate.getMonth()] + " " + tmpDate.getFullYear();
  }
  else if (withDate && withTime)
    return weekAbbreviations[tmpDate.getDay()] + " " + tmpDate.getDate() + " " + monthAbbreviations[tmpDate.getMonth()] + " " + tmpDate.getFullYear()  + " " + hours + ":" + minutes;
  else if (!(withDate) && withTime) {
    return hours + ":" + minutes
  } else {
    return ''
  }
}


export function simpleDate(date: string | Date): string {
  var tmpDate: Date = new Date();

  if(typeof date === 'string' || date instanceof String && !(date instanceof Date)){
    tmpDate = from_YYYYMMDDHHMMSS(date);
  } else if(date instanceof Date){
    tmpDate = date;
  }
  var dayOfMonth = tmpDate.getDate().toString()
  if(tmpDate.getDate() >= 0 && tmpDate.getDate() <= 9){
    dayOfMonth = "0" + tmpDate.getDate().toString()
  }

  var monthOfYear = tmpDate.getMonth().toString()
  if(tmpDate.getMonth() >= 0 && tmpDate.getMonth() <= 9){
    monthOfYear = "0" + (tmpDate.getMonth()+1).toString()
  }

  return monthOfYear + "-" + dayOfMonth + "-" + tmpDate.getFullYear();
}